<template>
  <div class="map-legend">
    <div class="map-legend__group">
      <p class="map-legend__title">{{ $t('attention-map-panel.legend-condition') }}</p>
      <ul class="map-legend__items">
        <li
          v-for="condition in conditions"
          :key="condition"
          class="map-legend__item"
        >
          <span class="map-legend__dot" :class="`map-legend__dot--${condition}`" />
          {{ $t(`attention-map-panel.condition.${condition}`) }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { assetConditionsBySeverity } from '@/domain/enums/assetCondition';

export default {
  name: 'MapLegend',
  computed: {
    conditions() {
      return assetConditionsBySeverity;
    },
  },
};
</script>

<style lang="sass" scoped>

// Mesma moldura e os mesmos tamanhos dos blocos da Barra de Controles:
// superfície do painel, borda fina e caixa alta miúda nos títulos. Fixo, e não
// proporcional: a legenda explica a tela, não é a tela.
.map-legend
  background: var(--panel-surface)
  border: 1px solid var(--panel-border)
  border-radius: 6px
  box-shadow: 0 2px 8px var(--panel-card-shadow)
  color: var(--panel-text)
  display: flex
  font-size: 0.74rem
  gap: 1.1rem
  padding: 0.5rem 0.8rem

  &__title
    color: var(--panel-text-muted)
    font-size: 0.66rem
    font-weight: 700
    letter-spacing: 0.07em
    margin: 0 0 0.3rem
    text-transform: uppercase

  &__items
    list-style: none
    margin: 0
    padding: 0

  &__item
    align-items: center
    display: flex
    gap: 0.4rem
    line-height: 1.5

  &__dot
    border-radius: 50%
    display: inline-block
    height: 10px
    width: 10px

    &--critical
      background: var(--condition-critical)

    &--attention
      background: var(--condition-attention)

    &--normal
      background: var(--condition-normal)

    &--out-of-service
      background: var(--condition-out-of-service)


</style>
